import React from 'react';
import { AlertOccurrent } from '@nile/components';
import { getTranslatedText } from '@nile/components';
import { useIntl } from 'react-intl';

interface OccurrenceCellProps {
  cell: {
    row: {
      original: {
        id: string;
        message: string;
        severity: string;
        status: string;
        description: string;
        createdTime: string;
        resolvedTime?: string;
        occurrenceCount: number;
        asset: any;
        policy: any;
      };
    };
    value?: number;
    column?: {
      actions?: {
        onViewOccurrences?: (alertData: any) => void;
      };
    };
  };
}

const OccurrenceCell = (props: OccurrenceCellProps) => {
  const { cell } = props;
  const intl = useIntl();
  const alertData = cell?.row?.original;
  const occurrenceCount = alertData?.occurrenceCount || cell?.value;

  if (!occurrenceCount) {
    return null;
  }

  const handleViewClick = () => {
    if (cell?.column?.actions?.onViewOccurrences) {
      cell.column.actions.onViewOccurrences({
        id: alertData?.id,
        message: alertData?.message,
        severity: alertData?.severity,
        status: alertData?.status,
        description: alertData?.description,
        createdTime: alertData?.createdTime,
        resolvedTime: alertData?.resolvedTime
          ? alertData.resolvedTime
          : getTranslatedText(intl, 'app.noData.message'),
        occurrenceCount: alertData?.occurrenceCount,
        asset: alertData?.asset,
        policy: alertData?.policy
      });
    }
  };

  return (
    <AlertOccurrent count={occurrenceCount} onViewClick={handleViewClick} />
  );
};

export default OccurrenceCell;
